/* initiate AOS animations */
//AOS.init();

jQuery('a[href="#top"]').click(function(){
    jQuery('html, body').animate({scrollTop:0}, 'smooth');
});



$('.grid').masonry({
  // options
  itemSelector: '.grid-item',
  columnWidth: 200
});
// layout Masonry after each image loads
$grid.imagesLoaded().progress( function() {
  $grid.masonry('layout');
});